export enum EAlertType {
  'none' = 'none',
  'active' = 'active',
  'recalled' = 'recalled',
  'callAlert' = 'callAlert',
  'callAlertEnded' = 'callAlertEnded',
  'reactivate' = 'reactivate',
  'ended' = 'ended',
  'started' = 'started',
  'shared' = 'shared',
  'newMuster' = 'newMuster',
  'muster' = 'muster',
  'alarmWarn' = 'alarmWarn',
  'selfAlarmOpenApp' = 'selfAlarmOpenApp',
  'selfAlarmClosedApp' = 'selfAlarmClosedApp',
  'reply' = 'reply',
}

export enum ENotificationDataProperties {
  'groupMessage' = 'groupMessage',
  'reply' = 'reply',
  'recalled' = 'recalled',
  'onCallAlert' = 'onCallAlert',
  'onCallAlertEnded' = 'onCallAlertEnded',
  'checklistReactivated' = 'checklistReactivated',
  'checklistEnded' = 'checklistEnded',
  'checklistStarted' = 'checklistStarted',
  'checklistShared' = 'checklistShared',
  'newMuster' = 'newMuster',
  'muster' = 'muster',
  'personalAlarmWarning' = 'personalAlarmWarning',
  'personalAlarmOneMinuteWarning' = 'personalAlarmOneMinuteWarning',
  'personalAlarmDispatched' = 'personalAlarmDispatched',
  'data' = 'data',
  'entityChangedEvent' = 'entityChangedEvent',
  'messageId' = 'messageId',
}

export enum EIdTypes {
  'mID' = 'mID',
  'replyMID' = 'replyMID',
  'recalledMID' = 'recalledMID',
  'iD' = 'iD',
  'messageId' = 'messageId',
}

export enum SendMessageType {
  RegularMessage = 0,
  Chat = 1,
  Alarm = 2,
  Broadcast = 3,
  GroupAdditionNormal = 4,
  LogNotes = 10,
  HoldingStatement = 9,
  Forwarded = 12,
}

export enum ENotificationType {
  'message' = 'message',
  'checklist' = 'checklist',
  'IamOk' = 'IamOk',
  'onCallAlert' = 'onCallAlert',
}

export type Notification = {
  messageId: number | null;
  title: string;
  description: string;
  confirmBtnTx?: string;
  cancelBtnTx?: string;
  closeBtnOnly?: boolean;
  alert?: EAlertType;
  showIcon?: boolean;
  tenantName?: string;
  tenantId?: number;
};
